<prism-select 
  [selectOptions]="options"
  [label]="label"
  [placeHolder]="multiSelect ? 'Select Grade(s)' : 'Select a Grade'"
  [control]="control"
  [required]="required"
  [readOnly]="readOnly"
  [allowDeselect]="true"
  [labelClass]="labelClass"
  (onSelected)="emitgrade($event)"
  [multiSelect]="multiSelect">
</prism-select>
